import { Component, OnInit, Inject } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ShipmentManifestFacade } from '../../../common/facade/ShipmentManifestFacade';
import { ShipmentManifest } from '../../../common/model/ShipmentManifest';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-package-reception',
  templateUrl: './package-reception.component.html',
  styleUrls: ['./package-reception.component.css']
})
export class PackageReceptionComponent implements OnInit {

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];

  rows: ShipmentManifest[];
  private _filteredData: ShipmentManifest[];

  deliveryCode = '';
  startShipmentDate = new Date();
  totalManifest = 0;
  manifestReceived = 0;
  selectedItem: ShipmentManifest = null;
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;

  titleDelivery = res.Delivery;
  titleTransportStartDateMayus = res.TransportStartDateMayus;
  titleShippingNumberIncludedMayus = res.ShippingNumberIncludedMayus;
  titleShippingNumberReceivedMayus = res.ShippingNumberReceivedMayus;
  lblSearch = res.Search;
  lblShippingNumber = res.ShippingNumber;
  lblStatus = res.Status;
  lblDate = res.Date;
  lblReceivedBy = res.ReceivedBy;
  lblReferenceReception = res.ReferenceReception;
  lblCancelShippingNumber = res.CancelShippingNumber;
  lblYouReallyWantCancelShippingNumber = res.YouReallyWantCancelShippingNumber;
  lblYes = res.Yes;
  lblCancel = res.Cancel;
  public extras: NavigationExtras;
  public path = 'inventory/shipments';
  private _storeId = -1;
  private _startDate: string;
  private _endDate: string;
  private _organizationId = null;

  isSpanish = true;

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService
    , private _router: Router
    , private _facadeShipmentManifest: ShipmentManifestFacade
    , private _activatedRoute: ActivatedRoute
    , public strings: Strings
  ) { }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    let language = 0;
    if (!this.isSpanish) {
        language = 1;
    }

    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this.deliveryCode = id;
    this.getShipmentManifest(id, language);
  }

  getShipmentManifest(id: String, language: number) {
    this.loading = true;
    // Obtener listado de mercancía a ingresar
    this._facadeShipmentManifest.GetAllByDeliveryCode(id, language).subscribe(result => {
      if (result.completed) {

        if (result.data.length > 0)
        {
          this.rows = result.data;
          this._filteredData = result.data;

          this.startShipmentDate = result.data[0].startShipmentDate;
          this.totalManifest = result.data.length;

          result.data.forEach(element => {
            if (element.packageReceptionId !== 0) {
              this.manifestReceived += 1;
            }
          });
        }
        else 
        {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertNoDeliveryInfoWasObtained) + '</strong>', 'danger');
        }

        const navigation = this._activatedRoute.queryParams.subscribe(params => {
          this._storeId = Number(params['storeid']);
          this._startDate = params['startDate'];
          this._endDate = params['endDate'];
          this._organizationId = params['organizationid'];
          this.extras = {
              queryParams: {
                  'storeid': this._storeId
                  , 'startDate': this._startDate
                  , 'endDate': this._endDate
                  , 'organizationid': this._organizationId
              }
          };
        });
        this.loading = false;
      } else {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertErrorGettingInformation) + '</strong>', 'danger');
        this.loading = false;
      }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
  }

  onViewDetail(code: string) {
    this._router.navigate(['/inventory/receptions-detail/', code]);
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  cancelTalon() {
    this.loading = true;
    this._facadeShipmentManifest.Cancel(this.selectedItem.manifestNumber).subscribe(result => {
      if (result.completed) {
        this.loading = false;
        let language = 0;
        if (!this.isSpanish) {
            language = 1;
        }
        this.getShipmentManifest(this.deliveryCode, language);
      } else {
        if (result.message.length > 0) {
          this.addAlert('<strong>' + result.message + '</strong>', 'danger');
        } else {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertErrorGettingInformation) + '</strong>', 'danger');
        }
        this.loading = false;
      }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
  }
  validatePermissions()
  {
    this.permissionsList = this._storage.get('permissions')
      this.permissionsList.forEach(element => {
          if (element.name == Permissions.GeneralAccess || element.name == Permissions.AdminDevicesCreate)
      {
        this.visibleAdd = true;
      }
    });

      this.permissionsList.forEach(element => {
          if (element.name == Permissions.GeneralAccess || element.name == Permissions.AdminDevicesEdit)
      {
        this.visibleEdit = true;
      }
    });
  }
}
